import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Col, Container, Row, Table } from 'reactstrap';
import FormCard from '../../../shared/components/custom/FormCard';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';
import useModal from '../../../shared/hooks/useModal';
import Api from '../../../util/api';
import DeleteModal from '../../../shared/components/custom/DeleteModal';
import { partial } from '../../../util/translation/translation';
import { formatDate } from '../../../util/date-and-time';

const GoalSponsorPrizeList = ({ setLoading }) => {
  const history = useHistory();
  const [subscriptionPrizes, setSubscriptionPrizes] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const [handleModal, visible, deleteID] = useModal();
  const p = partial('goalSponsor');
  const s = partial('shared');

  const fetchSubscriptionPrizes = async () => {
    setLoading(true);
    try {
      const resSubscriptionPrizes = await Api.goalSponsor.prizes.getAllPrizes();
      setSubscriptionPrizes(resSubscriptionPrizes);
      setLoading(false);
    } catch (err) {
      toast.error(p('prizesRetrievingERROR'));
      setLoading(false);
    }
    setHasFetched(true);
  };
  useEffect(() => {
    fetchSubscriptionPrizes();
  }, []);
  const deleteSubscriptionPrize = async () => {
    setLoading(true);
    try {
      await Api.goalSponsor.prizes.deletePrize(deleteID);
      toast.success(`${p('prizeDeleted')}`);
    } catch (err) {
      toast.error(p('errorRemovingPrize'));
    } finally {
      handleModal();
      fetchSubscriptionPrizes();
    }
  };

  const renderSubscriptionPrizes = () => {
    return subscriptionPrizes.map((subscriptionPrize, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`subscription-prize-${subscriptionPrize.id}`}
      >
        <td>
          <div className="flex-Vcenter">
            <Link
              to={`/goal-sponsor/subscription-prizes/edit/${subscriptionPrize.id}`}
            >
              {subscriptionPrize.title}
            </Link>
          </div>
        </td>
        <td>{formatDate(subscriptionPrize.createdAt)}</td>
        <td>{subscriptionPrize.planCount || 0}</td>
        <td>
          <div className="icon-actions">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              onClick={() =>
                history.push(
                  `/goal-sponsor/subscription-prizes/edit/${subscriptionPrize.id}`
                )
              }
              title={s('edit')}
              id={`edit-prize-${subscriptionPrize.id}`}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              onClick={() => handleModal(subscriptionPrize.id)}
              title={s('delete')}
              tone="danger"
              id={`delete-prize-${subscriptionPrize.id}`}
            />
          </div>
        </td>
      </tr>
    ));
  };
  return (
    <Container>
      <DeleteModal
        visible={visible}
        type={p('subscriptionPrize')}
        handleModal={handleModal}
        modalAction={deleteSubscriptionPrize}
      />
      <Row>
        <Col>
          <FormCard
            title={p('prizes')}
            actions={
              <Link to="/goal-sponsor/subscription-prizes/create">
                <Button size="sm" color="primary" className="mb-0">
                  {s('create')}
                </Button>
              </Link>
            }
            bodyClassName="form-card__body--flush"
            className="mb-3"
          >
            <Table responsive striped className="table--roomy">
              <thead>
                <tr>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">{s('name')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">
                      {s('publicationDate')}
                    </div>
                  </th>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">
                      {p('plansCount')}
                    </div>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {hasFetched && subscriptionPrizes.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="text-muted">
                      {p('noPrizes')}
                    </td>
                  </tr>
                ) : (
                  renderSubscriptionPrizes()
                )}
              </tbody>
            </Table>
          </FormCard>
        </Col>
      </Row>
    </Container>
  );
};

export default GoalSponsorPrizeList;
